import React, { CSSProperties } from "react";

export default function IconStar(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 3.25a1.25 1.25 0 0 1 1.17.82l1.8 4.96 4.96 1.8a1.23 1.23 0 0 1 .82 1.17c0 .26-.08.5-.22.72l-.12.14c-.14.14-.3.25-.48.31l-4.96 1.8-1.8 4.96-.08.17a1.25 1.25 0 0 1-1.09.64l-.19-.01a1.25 1.25 0 0 1-.36-.11l-.16-.1c-.21-.15-.37-.35-.46-.6l-1.8-4.95-4.96-1.8a1.25 1.25 0 0 1 0-2.34l4.96-1.8 1.8-4.96A1.25 1.25 0 0 1 12 3.25Zm-1.1 6.46a2 2 0 0 1-1.2 1.2L6.7 12l3 1.1.21.08a2 2 0 0 1 1 1.1L12 17.3l1.1-3.01.08-.2a2 2 0 0 1 1.1-1L17.3 12l-3.01-1.08a2 2 0 0 1-1.2-1.2L12 6.7l-1.08 3Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
